import React from 'react'
import AvatarWithFallback from './AvatarWithFallback'
import Assets from 'app/configs/assetConfigs'
export default (props) => {
  return (
    <AvatarWithFallback fallbackSrc={Assets.personSilhouetteImage} {...props} />
  )
}
